import { render, staticRenderFns } from "./hydrology.vue?vue&type=template&id=f067bd2a&scoped=true&"
import script from "./hydrology.vue?vue&type=script&lang=js&"
export * from "./hydrology.vue?vue&type=script&lang=js&"
import style0 from "./hydrology.vue?vue&type=style&index=0&id=f067bd2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f067bd2a",
  null
  
)

export default component.exports